import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { useI18n } from "../../contexts/I18nContext";
import { Card } from "../../components/ui/card";
import { Users, CalendarOff, Coins, Briefcase, BarChart3 } from "lucide-react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

function Stat({ icon: Icon, label, value, to }) {
  const body = (
    <Card className="p-5 border shadow-none card-hover smooth">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-wider text-muted-foreground font-semibold">{label}</div>
          <div className="text-3xl font-bold mt-2 text-primary">{value}</div>
        </div>
        <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary grid place-items-center"><Icon className="w-5 h-5" /></div>
      </div>
    </Card>
  );
  return to ? <Link to={to}>{body}</Link> : body;
}

export default function HrDashboardPage() {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/hr/dashboard").then(r => setD(r.data)); }, []);
  if (!d) return <div className="p-8 text-muted-foreground">...</div>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-semibold flex items-center gap-3"><Users className="w-7 h-7 text-primary" /> {t("hr")}</h1>
        <p className="text-sm text-muted-foreground mt-1">{t("period")}: {d.current_period}</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat icon={Users} label={t("total_employees")} value={`${d.active_employees}/${d.total_employees}`} to="/hr/employees" />
        <Stat icon={CalendarOff} label={t("pending") + " · " + t("leaves")} value={d.pending_leaves} to="/hr/leaves" />
        <Stat icon={Coins} label={t("net") + " · " + d.current_period} value={d.current_payroll_net.toLocaleString() + " SAR"} to="/hr/payroll" />
        <Stat icon={Briefcase} label={t("recruitment")} value={d.open_jobs} to="/hr/recruitment" />
      </div>

      <Card className="p-5 border shadow-none">
        <h3 className="font-semibold mb-4 flex items-center gap-2"><BarChart3 className="w-4 h-4 text-primary" /> {t("department")}</h3>
        <div className="h-64">
          <ResponsiveContainer>
            <BarChart data={d.by_department || []}>
              <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
              <XAxis dataKey="department" fontSize={11} />
              <YAxis fontSize={11} allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="count" fill="hsl(var(--primary))" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
}
